module.exports = __webpack_public_path__ + "media/images/info-square-0eb1d329f560f35ca1e3816ebfebf9da.svg";